const devUrl =
  'https://ooofurxrbg.execute-api.ap-southeast-2.amazonaws.com/development'
const testUrl =
  'https://ooofurxrbg.execute-api.ap-southeast-2.amazonaws.com/testing'
const productionUrl =
  'https://ooofurxrbg.execute-api.ap-southeast-2.amazonaws.com/production'

export { devUrl, testUrl, productionUrl }
